import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Modal, Button } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function PagesCrud() {


  const [pagesList, setPagesList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [pageTypes, setPageTypes] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [pageToDelete, setPageToDelete] = useState(null);
  const [loading, setLoading] = useState(true);

  const callApiPageContent = async () => {
    try {
      const headers = {
        'x-access-token': localStorage.getItem('jwttoken')
      };
      const url = process.env.REACT_APP_API_URL + 'pages/showAll';
      const response = await axios.get(url, { headers });
      setPagesList(response.data);
      setFilteredList(response.data);
    } 
    catch (error) {
      console.log(error);
      toast.error("Failed to load pages",{ theme: "colored"});
    } finally {
      setLoading(false);
    }
  }

  const fetchPageTypes = async () => {
    try {
      const headers = {
        'x-access-token': localStorage.getItem('jwttoken')
      };
      const url = process.env.REACT_APP_API_URL + 'pages/getPageTypes';
      const response = await axios.get(url, { headers });
      setPageTypes(response.data.pageTypes);
    } catch (error) {
      console.error("Error fetching page types: ", error);
    }
  };

  useEffect(() => {
    callApiPageContent();
    fetchPageTypes();
  }, [])

  useEffect(() => {
    const results = pagesList.filter(item => 
      (item.pagename || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.pageid || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.pagetitle || '').toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredList(results);
  }, [searchTerm, pagesList]);

  const handleDeletePage = async () => {
    if (!pageToDelete) return;
    try {
      const headers = {
        'x-access-token': localStorage.getItem('jwttoken')
      };
      const url = process.env.REACT_APP_API_URL + `pages/delete/${pageToDelete.srno}`;
      await axios.delete(url, { headers });
      setShowDeleteModal(false);
      setPagesList(prev => prev.filter((item) => item.srno !== pageToDelete.srno));
      toast.success("Page deleted successfully",{theme: "colored"});
      setShowDeleteModal(false);
      setPageToDelete(null);
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete page",{ theme: "colored"});
      setShowDeleteModal(false);
    }
  };

  const renderLayoutBadge = (val, label) => (
    <span className={`badge ${val === 1 ? 'bg-primary' : 'bg-light text-dark'} me-1`} title={label}>
      {label[0]}
    </span>
  );

  return (
    <div className="main-card shadow-sm mt-4">
      <ToastContainer />
      
      {/* Toolbar - Styled like ContactList */}
      <div className="toolbar-container d-flex justify-content-between align-items-center p-3">
        <h2 className="page-title mb-0">Pages Management</h2>
        <div className="d-flex align-items-center gap-3">
          <span className="results-count text-muted">
            {filteredList.filter(item => item.isactive === 1).length} active pages
          </span>
          <input
            type="text"
            className="search-box form-control"
            placeholder="Search by Name, Title, or ID"
            style={{ width: '280px' }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
           <Link to="/createpage" className="btn-add-primary">
              + Create New Page
            </Link>
        </div>
      </div>

      {/* Header Panel - Styled like ContactList */}
      <div className="table-header-panel bg-primary text-white p-2 px-3">
        Master Pages Configuration List
      </div>

      {/* Table Section - Improved Scannability */}
      <div className="table-responsive">
        <table className="custom-table table table-hover mb-0 align-middle" style={{ fontSize: '0.85rem' }}>
          <thead className="table-light">
            <tr>
              <th style={{ width: '50px' }}>SR</th>
              <th>Page Details</th>
              <th>Type/Theme</th>
              <th className="text-center">Menu</th>
              <th className="text-center">Security</th>
              <th className="text-center">Layout (H/F/L/R)</th>
              <th className="text-center">Status</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="8" className="text-center p-5">Loading Pages...</td></tr>
            ) : filteredList.filter(item => item.isactive === 1).length === 0 ? (
              <tr><td colSpan="8" className="text-center p-5 text-muted">No pages matching your search.</td></tr>
            ) : (
              filteredList
                .filter(item => item.isactive === 1)
                .map((item, index) => (
                  <tr key={item.srno}>
                    <td>{index + 1}</td>
                    <td>
                      <div className="fw-bold text-primary">{item.pagename}</div>
                      <div className="text-muted small">ID: {item.pageid}</div>
                      <div className="text-muted extra-small" style={{fontSize: '0.7rem'}}>{item.pageurlname}</div>
                    </td>
                    <td>
                      <div>{pageTypes.find(t => t.id === item.pagetype)?.name || item.pagetype}</div>
                      <span className="badge bg-info-subtle text-info border border-info-subtle px-2">
                        {item.pagetheme}
                      </span>
                    </td>
                    <td className="text-center">
                      {item.tobeaddedinmenu === 1 ? 
                        <span className="text-success">Yes</span> : <span className="text-muted">No</span>}
                    </td>
                    <td className="text-center">
                      {item.issecure === 1 ? 
                        <span className="badge bg-danger-subtle text-danger border border-danger-subtle">Secure</span> : 
                        <span className="badge bg-success-subtle text-success border border-success-subtle">Public</span>
                      }
                    </td>
                    <td className="text-center">
                      {renderLayoutBadge(item.hasheader, "Header")}
                      {renderLayoutBadge(item.hasfooter, "Footer")}
                      {renderLayoutBadge(item.hasleftsidebar, "Left")}
                      {renderLayoutBadge(item.hasrightsidebar, "Right")}
                    </td>
                    <td className="text-center">
                      <span className="text-success" style={{ fontWeight: '600' }}>● Active</span>
                    </td>
                    <td className="text-center">
                      <div className="d-flex gap-2 justify-content-center">
                        <Link to={`/updatepage/${item.srno}`} className="btn btn-outline-info btn-sm">
                          Edit
                        </Link>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => { setPageToDelete(item); setShowDeleteModal(true); }}
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
            )}
          </tbody>
        </table>
      </div>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
      <Modal.Header closeButton><Modal.Title>Confirm Delete</Modal.Title></Modal.Header>
      <Modal.Body>
        Are you sure you want to delete <strong>{pageToDelete?.pagename}</strong>?
      </Modal.Body>
      <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
          <Button variant="danger" onClick={handleDeletePage}>Delete</Button>
      </Modal.Footer>
  </Modal>
    </div>
  );
}

export default PagesCrud;
